// Home.js
import React, { useState } from "react";
import ListItem from "./ListItem";
import "../App.css";
import "../index.css";

const Home = ({ data, stationsData }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = data.filter((item) =>
    item.StationName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <input
        type="search"
        placeholder="Hledej..."
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          padding: "12px 20px", // Padding
          margin: "8px 0", // Margin
          boxSizing: "border-box", // Box sizing
          borderRadius: "10px", // Border radius
          width: "70%",
          marginTop: "90px",
          marginBottom: "30px",
          height: "50px",
          border: "none",
        }}
      />
      {filteredData.map((item) => {
        const stationData = stationsData.find(
          (station) => station.name === item.StationName
        );
        const lastTimeStampDate = new Date(item.LastTimeStamp);
        const eightHoursAgo = new Date(Date.now() - 8 * 60 * 60 * 1000);
        const imageProp = lastTimeStampDate <= eightHoursAgo;

        return (
          <ListItem
            key={item.StationName}
            name={item.StationName}
            coinName={stationData ? stationData["coin 1"] : "coin 1"}
            numberOfPcs={item.Hopper_Total_OUT1}
            imageProp={imageProp}
            PostTimeStamp={item.LastTimeStamp}
            Hopper_Total_OUT2={item.Hopper_Total_OUT2}
            coinName2={stationData ? stationData["coin 2"] : ""}
            coin2={stationData && stationData["coin 2"] !== ""}
            IdMachine={item.IdMachine}
          />
        );
      })}
    </div>
  );
};

export default Home;
